module.exports = __webpack_public_path__ + "stitcher-62aa2526235ef3da59c3.png";